// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2c2DD","detailsBorder":"styles_detailsBorder__14aVz"};